import { api } from "../../utils/api";
import { useMutation, useInfiniteQuery } from "@tanstack/react-query";
export const getUserNotifications = async (page = 1, perPage = 20) => {
  const response = await api.get(`notifications/?page=${page}&perPage=${perPage}`);
  return response.data;
};
export const deleteUserNotification = async (id) => {
  const response = await api.delete(`notifications/?notification_id=${id}`);
  return response.data.data;
};
export const markAllNotificationsAsRead = async () => {
  const response = await api.delete(`notifications/`);
  return response.data;
};
export const createNotification = async (body) => {
  const res = await api.post("notifications/", body);
  return res.data;
};
export const useGetNotifications = () =>
  useInfiniteQuery({
    queryKey: ["notifications"],
    queryFn: async ({ pageParam = 1 }) => {
      let res = await getUserNotifications(pageParam, 20);
      return {
        items: res, // array
        pagination: res.pagination,
        nextPage: res.pagination.hasNext ? res.pagination.currentPage + 1 : undefined,
      };
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage) => lastPage.nextPage,
  });
export const useCreateNotification = () => {
  return useMutation({
    mutationKey: ["create_notification"],
    mutationFn: (data) => createNotification(data),
  });
};
export const useDeleteNotification = () => {
  return useMutation({
    mutationKey: ["deleteNotification"],
    mutationFn: (notificationId) => deleteUserNotification(notificationId),
  });
};
export const useMarkAllNotificationsAsRead = () => {
  return useMutation({
    mutationKey: ["markAllNotificationsAsRead"],
    mutationFn: () => markAllNotificationsAsRead(),
  });
};
